import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import { type IQuestionSchema } from "@types";

export interface ISendLeadBody {
  name?: string;
  email?: string;
  phone: string;
  onboardingInfo: Partial<IQuestionSchema> & { suggestions?: string[] };
  gclid?: string;
  fbclid?: string;
  msclkid?: string;
  origin?: string;
  productType?: string;
}

export interface ISendEmailLeadWithConsentBody {
  email: string;
  name?: string;
  marketingConsent: true;
  onboardingInfo: Partial<IQuestionSchema> & { suggestions?: string[] };
}

export interface ISendPhoneLeadWithConsentBody {
  phone: string;
  name?: string;
  marketingConsent: true;
  onboardingInfo: Partial<IQuestionSchema> & { suggestions?: string[] };
}

export const ONBOARDING_API_REDUCER_KEY = "onboardingApi";
export const onboardingApi = createApi({
  reducerPath: ONBOARDING_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      ...extraOptions,
      isExternalService: true,
    }),
  endpoints: (builder) => ({
    sendLead: builder.mutation<void, ISendLeadBody>({
      query: (body) => ({
        url: "/onboarding/send-lead",
        method: "POST",
        body,
      }),
    }),
    sendEmailLeadWithConsent: builder.mutation<void, ISendEmailLeadWithConsentBody>({
      query: (body) => ({
        url: "/onboarding/email-lead-with-consent",
        method: "POST",
        body,
      }),
    }),
    sendPhoneLeadWithConsent: builder.mutation<void, ISendPhoneLeadWithConsentBody>({
      query: (body) => ({
        url: "/onboarding/phone-lead-with-consent",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendLeadMutation, useSendEmailLeadWithConsentMutation, useSendPhoneLeadWithConsentMutation } =
  onboardingApi;
